import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';
import './PlaceholderPage.css';

interface PlaceholderPageProps {
  title: string;
  description?: string;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title, description }) => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  return (
    <div className={`placeholder-page ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className="placeholder-content">
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        <div className="placeholder-icon">🚧</div>
        <p className="coming-soon">{t('common.loading')}</p>
      </div>
    </div>
  );
};

export default PlaceholderPage;
